import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';

import { CourseTestimonialsCarousel, CourseTestimonialProps } from '~/components';

export const CourseTestimonials: React.FC<
  PropsWithChildren<{ testimonials: CourseTestimonialProps }>
> = ({ testimonials }) => {
  return (
    <Box>
      {testimonials.data && <CourseTestimonialsCarousel button={null} items={testimonials.data} />}
    </Box>
  );
};
